export const newsItems = [
  {
    id: 'tsirs-ca-us',
    date: '2025-01-01', // update
    title: 'The Stranger in Room Six is out now in Canada and the US!',
    imageKey: 'tsirscover',
    variant: 'links',
    links: [
      {
        label: 'Order in Canada',
        url: 'https://www.penguinrandomhouse.ca/books/801285/the-stranger-in-room-six-by-jane-corry/9780385702621',
      },
      {
        label: 'Order in the US',
        url: 'https://www.penguinrandomhouse.com/books/801285/the-stranger-in-room-six-by-jane-corry/',
      },
    ],
  },
  {
    id: 'events-upcoming',
    title:
      'I have some exciting events coming up. Join me at the Crime Writing Festival at Basingstoke Discovery Centre or the Plymouth Literary Festival.',
    imageKey: 'janetsirs',
    variant: 'cta',
    cta: {label: 'Find all upcoming events', to: '/events'},
  },
  {
    id: 'domestika-course',
    title:
      'I was thrilled when Domestika asked me to write a short story course. To celebrate the launch, it’s being offered at a promotional price for a limited period.',
    imageKey: 'domestica',
    variant: 'link',
    link: {
      label: 'Find the course',
      url: 'https://www.domestika.org/en/courses/5207-creative-writing-techniques-for-short-stories/janecorryauthor',
    },
  },

  // --- the rest of your News page items (newest to oldest ideally) ---

  {
    id: 'idoat-bestseller-canada',
    title:
      'I’m very excited that I Died On a Tuesday was number 2 in the best-selling fiction paperbacks in Canada shortly after publication in January.',
    imageKey: 'canadalist',
    variant: 'imageOnly',
    imageLinkKey: 'canadalist', // click-to-enlarge behaviour
    imageLinkLabel: 'click to enlarge',
  },

  {
    id: 'idoat-ca-us',
    title: 'I Died On a Tuesday is now available in Canada and the US.',
    imageKey: 'idoatcanada',
    variant: 'links',
    links: [
      {
        label: 'Order in Canada',
        url: 'https://www.penguinrandomhouse.ca/books/735470/i-died-on-a-tuesday-by-jane-corry/9780385697934',
      },
      {
        label: 'Order in the US',
        url: 'https://www.penguinrandomhouse.com/books/735470/i-died-on-a-tuesday-by-jane-corry/',
      },
    ],
  },

  {
    id: 'podcast-charlie-lovett',
    title:
      'Recently I was lucky enough to be interviewed by top-selling US author Charlie Lovett on his podcast.',
    imageKey: 'podcastImage',
    variant: 'link',
    link: {
      label: 'Listen to the episode',
      url: 'https://charlielovett42.podbean.com/e/jane-corry-1152024-inside-the-writers-studio-episode-127/',
    },
  },

  {
    id: 'ctfy-ca-us',
    title:
      'Coming To Find You is now available in Canada and the US. Published by Doubleday Canada.',
    imageKey: 'ctfycanada',
    variant: 'links',
    links: [
      {
        label: 'Order (Penguin Random House)',
        url: 'https://www.penguinrandomhouse.com/books/735469/coming-to-find-you-by-jane-corry/',
      },
      {
        label: 'Order (Amazon US)',
        url: 'https://www.amazon.com/Coming-Find-You-Jane-Corry-ebook/dp/B0BYYNF1YX/',
      },
    ],
  },

  {
    id: 'tlwt-germany',
    title:
      "I'm delighted that The Lies We Tell has just been published in Germany by Piper Verlag GmbH.",
    imageKey: 'tlwtgerman',
    variant: 'link',
    link: {
      label: 'Order in Germany',
      url: 'https://www.amazon.de/Lies-We-Tell-Niemand-Thriller-ebook/dp/B0C1P7KZC5',
    },
  },

  {
    id: 'woman-and-home',
    title:
      "I'm absolutely thrilled that Coming To Find You is in the July issue of Woman & Home!",
    imageKey: 'ctfynewspaper',
    variant: 'link',
    link: {label: 'Woman & Home', url: 'https://www.womanandhome.com/'},
  },
];
